// store.ts

import { authReducer } from './auth/authSlice';
import { investmentReducer } from './project/investmentSlice'; // Add this import
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import persistConfig from './persistConfig'; // Import the persistConfig
import { stepperReducer } from './stepper/stepperSlice';
import { editInvestmentReducer } from './project/editInvestmentSlice';
import { companyServicesReducer } from './companyServices/companyServicesSlice';
import { editCompanyServicesReducer } from './companyServices/editCompanyServicesSlice';
import { completedProjectsReducer } from './completedProjects/completedProjectsSlice';
import { editCompletedProjectsReducer } from './completedProjects/editCompletedProjectsSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  investment: investmentReducer, // Add this reducer
  stepper: stepperReducer,
  editInvestment: editInvestmentReducer, // Add this to handle edit project data
  companyServices: companyServicesReducer,
  editCompanyServices: editCompanyServicesReducer, // Add this to handle edit company services data
  completedProjects: completedProjectsReducer,
  editCompletedProjects: editCompletedProjectsReducer, // Add this to handle edit completed projects data
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'REGISTER'],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
